import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { checkDocument, removeDirectivesFromDocument } from 'apollo-utilities';
import cloneDeep from 'fclone';
import gql from 'fraql';
var removedCache = new Map();

function addDependenciesToSelectionSet(selectionSet, dependencies) {
  var extraSelections = [];
  selectionSet.selections.forEach(function (selection) {
    if (selection == null || selection.kind !== 'Field' || selection.directives == null) {
      return;
    }

    var clientDirective = selection.directives.find(function (directive) {
      return directive.name.value === 'client';
    });

    if (clientDirective == null) {
      return;
    }

    var typeArg = clientDirective.arguments.find(function (arg) {
      return arg.name.value === 'type';
    });

    if (!typeArg) {
      return;
    }

    var type = typeArg.value.value;
    var selectionName = selection.name.value;
    var directiveDependencies = dependencies && dependencies[type] && dependencies[type][selectionName] || null;

    if (directiveDependencies == null) {
      return;
    }

    var dependenciesFragmentDoc = gql(_templateObject(), directiveDependencies);
    var dependenciesFragment = dependenciesFragmentDoc.definitions[0];
    delete dependenciesFragment.name;
    extraSelections.push(dependenciesFragment);
  });
  selectionSet.selections.forEach(function (selection) {
    var kind = selection.kind;

    if ((kind === 'Field' || kind === 'InlineFragment') && selection.selectionSet != null) {
      addDependenciesToSelectionSet(selection.selectionSet, dependencies);
    }
  });
  selectionSet.selections = _toConsumableArray(selectionSet.selections).concat(extraSelections);
}

export function addDependenciesToDocument(doc, dependencies) {
  var docClone = cloneDeep(doc);
  var definitions = docClone.definitions;
  definitions.forEach(function (_ref) {
    var selectionSet = _ref.selectionSet;
    addDependenciesToSelectionSet(selectionSet, dependencies);
  });
  return docClone;
}
export function removeClientSetsFromDocument(query) {
  // caching
  var cached = removedCache.get(query);

  if (cached) {
    return cached;
  }

  checkDocument(query);
  var docClone = removeDirectivesFromDocument([{
    remove: true,
    test: function test(directive) {
      return directive.name.value === 'client';
    }
  }], query);
  removedCache.set(query, docClone);
  return docClone;
}
export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export function extractResolversAndDependencies(resolversAndDeps) {
  var result = Object.keys(resolversAndDeps).reduce(function (memo, typeName) {
    var _resolversAndDeps$typ = resolversAndDeps[typeName],
        resolvers = _resolversAndDeps$typ.resolvers,
        dependencies = _resolversAndDeps$typ.dependencies;

    if (dependencies == null || typeof dependencies === 'function') {
      return {
        resolvers: _objectSpread({}, memo.resolvers, _defineProperty({}, typeName, resolversAndDeps[typeName])),
        dependencies: _objectSpread({}, memo.dependencies, _defineProperty({}, typeName, {}))
      };
    }

    return {
      resolvers: _objectSpread({}, memo.resolvers, _defineProperty({}, typeName, resolvers)),
      dependencies: _objectSpread({}, memo.dependencies, _defineProperty({}, typeName, dependencies))
    };
  }, {});
  return result;
}
export function normalizeTypeDefs(typeDefs) {
  return typeof typeDefs === 'string' ? typeDefs : typeDefs.map(function (typeDef) {
    return typeDef.trim();
  }).join('\n');
}